/**
 * Public barrel export for the SortOptionItem component.
 * @module features/scouting/components/MobileTargetsToolbar/SortOptionItem
 */
export { default } from "./SortOptionItemContainer";
